import { useSession } from "./useSession";

export const useRecapIcons = () => {
  const { read } = useSession();

  const getSubRawProperty = (prop) => {
    const sub = read("filialeScelta");
    try {
      return sub[prop];
    } catch (error) {
      return "";
    }
  };

  const showMap = (city, address, coords) => {
    window.open("https://www.google.it/maps/place/" + address + "," + city + "/@" + coords.lat + "," + coords.lng + ",17z", "_blank");
  };
  const onShowMapClick = () => {
    showMap(getSubRawProperty("citta"), getSubRawProperty("indirizzo"), getSubRawProperty("coordinate"));
  };

  return {
    onShowMapClick,
  };
};
